<template>
	<Skeleton :paragraph="{ rows: 2 }" :title="false" :loading="baseStation == null">
		<div class="pd-sm-x">
			<div>
				<router-link :to="{ name: 'base-stations-edit', params: { id: baseStation.id } }">
					{{ baseStation.mntpnt_int }}
				</router-link>
			</div>
			<StatusDisplay
				v-if="baseStation.deleted"
				class="test-bs-status-display"
				source="deleted"
				prefix="baseStationStatus"
				:badgeDict="deletedStatusBadgeDict"
			/>
			<StatusDisplay
				v-if="!baseStation.deleted"
				class="test-bs-status-display"
				:source="baseStation"
				field="status"
				prefix="baseStationStatus"
				:badgeDict="baseStationStatusBadgeDict"
				badgeDefault="error"
			/><br>
			<StatusDisplay
				v-if="!baseStation.deleted"
				class="test-bs-status-live-display"
				:source="baseStation"
				field="status_live"
				prefix="baseStationStatus"
				:badgeDict="baseStationLiveStatusBadgeDict"
				badgeDefault="error"
			/>
		</div>
	</Skeleton>
</template>
<script>
import { Skeleton } from 'ant-design-vue';

import StatusDisplay from '@/components/common/StatusDisplay.vue';

const DELETED_STATUS_BADGE_DICT = {
	deleted: 'default',
};

const BASE_STATION_STATUS_BADGE_DICT = {
	working: 'success',
};

const BASE_STATION_LIVE_STATUS_BADGE_DICT = {
	live_data: 'success',
};

export default {
	components: {
		Skeleton, StatusDisplay,
	},
	props: {
		baseStation: {
			type: Object,
			required: false,
		},
	},
	setup() {
		return {
			deletedStatusBadgeDict: DELETED_STATUS_BADGE_DICT,
			baseStationStatusBadgeDict: BASE_STATION_STATUS_BADGE_DICT,
			baseStationLiveStatusBadgeDict: BASE_STATION_LIVE_STATUS_BADGE_DICT,
		};
	},
};
</script>
